import { ComponentProps } from 'react';
import clsx from 'clsx';

interface SpinnerProps extends ComponentProps<'div'> {
  size?: number;
  color?: 'brand' | 'white' | 'black';
  strokeWidth?: number;
}

export function Spinner({
  size = 20,
  color = 'brand',
  strokeWidth = 4,
  className,
  ...props
}: SpinnerProps) {
  return (
    <div
      className={clsx(
        'animate-spin rounded-full',
        color === 'brand' && 'border-brand-default/25 border-t-brand-default',
        color === 'white' && 'border-base-white/25 border-t-base-white',
        color === 'black' && 'border-neutral-default/25 border-t-neutral-default',
        className
      )}
      style={{
        height: size,
        width: size,
        borderWidth: strokeWidth,
      }}
      {...props}
    ></div>
  );
}
